<template>
  <div class="reporting-toolbar border-top border-bottom">
    <div class="container-fluid px-3 d-flex">
      <!-- Left -->
      <div class="flex-grow-1 d-flex align-items-center">
        <div>
          <h4 class="mb-0">{{ report.name }} <span v-if="!report.id">(Unsaved)</span></h4>
        </div>
      </div>
      <!-- / Left -->

      <!-- Right -->
      <div>
        <div class="btn-group ml-2">
          <button v-if="report && report.id"
           type="button" class="btn btn-itg" @click="attemptDeleteReport">
            <i class="fa fa-trash mr-1"></i> Delete
          </button>
        </div>
        <div class="btn-group ml-2">
          <button type="button" class="btn btn-itg" @click="exportResults">
            <i class="fa fa-download mr-1"></i> Export
          </button>
        </div>
        <div class="btn-group ml-2">
          <button type="button" class="btn btn-itg" @click="save">
            <i class="fa fa-save mr-1"></i> Save
          </button>
        </div>
      </div>
      <!-- / Right -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ReportingToolbar",
  methods: {
    ...mapActions('reportEditor', {
      saveReport: 'saveReport',
      promptNameAndSaveReport: 'promptNameAndSaveReport',
      exportResults: 'exportResults',
      deleteReport: 'deleteReport'
    }),

    attemptDeleteReport() {
      swal({
        title: "Are you sure you want to delete this report?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete"
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          this.deleteReport();
        }
      });
    },

    save() {
      if (this.report && this.report.id) {
        this.saveReport();
      } else {
        this.promptNameAndSaveReport();
      }
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      report: 'report'
    })
  }
}
</script>

<style scoped>
.reporting-toolbar {
  border-top: 1px #ebeff3 solid !important;
  border-bottom: 1px #cfd7df solid !important;
  padding-top: 11px;
  padding-bottom: 11px;
  box-shadow: 0 2px 4px 0 rgba(24, 50, 71, .08);
  z-index: 1;
}
</style>